/* eslint-disable no-unused-vars */
import axios from "axios";
import Cookies from "universal-cookie";
const cookies = new Cookies();

let token = getCookie("token_usuario_agendou");
const axiosClient = axios.create({
  //withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

function getCookie(name) {
  let cookieArray = document.cookie.split(";");
  for (let i = 0; i < cookieArray.length; i++) {
    let cookiePair = cookieArray[i].split("=");
    if (name == cookiePair[0].trim()) {
      return decodeURIComponent(cookiePair[1]);
    }
  }
  return null;
}

axiosClient.interceptors.request.use(
  (config) => {
    config.data = {
      ...config.data,
      token,
    };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosClient;
